import { _ as t } from "../internals/export.js";
import { d as o } from "../internals/date-to-iso-string.js";
t({
  target: "Date",
  proto: !0,
  forced: Date.prototype.toISOString !== o
}, {
  toISOString: o
});